import React, { Component, PropTypes } from 'react';
import { Media } from 'Util';
import {
  TextField,
  Styles,
  SelectField,
  Toggle,
  RaisedButton
} from 'material-ui';
import { Ozitor, LinkList } from 'components/Widgets';
import Constants from 'Constants';
import { StoreOverviewActions } from 'actions';

const { Spacing } = Styles;

const styles = {
  ozitor: {
    marginTop: Spacing.desktopGutter
  }
};

class StoreItemEditPanel extends Component {
  static propTypes = {
    price: PropTypes.object,
    videoUrl: PropTypes.string,
    presentation: PropTypes.string,
    isPublic: PropTypes.bool,
    ucpPeriod: PropTypes.number,
    type: PropTypes.number,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  state = {};

  componentWillUnmount() {
    clearTimeout(this._timer);
    this.change({});
  }

  statusChange = event => {
    this.change({
      public: event.target.checked
    });
  };

  changeVideo = event => {
    this.change({
      videoUrl: event.target.value
    });
  };

  changePrice = event => {
    const { price } = this.props;
    const gross = parseInt(event.target.value, 10);
    const net = gross / (price.gross / price.net || 1.25);
    this.change({
      price: {
        net,
        gross,
        discounted: gross
      }
    });
  };

  changePresentation = presentation => {
    this.change({
      presentation
    });
  };

  change(props) {
    const { id, type } = this.props;
    if (this._timer) {
      clearTimeout(this._timer);
    }
    this._timer = setTimeout(() => {
      if (this._save) {
        this._save = false;
        this.save({ id, type, ...props });
      } else {
        StoreOverviewActions.changeStoreItem({ id, type, ...props });
      }
      this._timer = null;
    }, 500);
  }

  queueSave = () => {
    if (this._timer) {
      this._save = true;
    } else {
      this.save();
    }
  };

  save = props => {
    const { id, type } = this.props;
    StoreOverviewActions.pushStoreItem({ id, type, ...props });
  };

  parseVideoUrl(videoUrl) {
    try {
      const provider = JSON.parse(videoUrl);
      provider.id = provider.src;
      return Media.getUrlFromProvider(provider);
    } catch (e) {
      return videoUrl;
    }
  }

  changeAccessTime = (event, selectedIndex, menuItem) => {
    this.change({
      ucpPeriod: menuItem.payload
    });
  };

  render() {
    const { price, presentation, isPublic, ucpPeriod, themeColor } = this.props;
    const videoUrl = this.parseVideoUrl(this.props.videoUrl);

    const month = 24 * 60 * 60 * 30;
    const year = 31536000;

    const menuItems = [
      {
        payload: null,
        text: this.context.getIntlMessage('invite.chooseAccessTime')
      },
      {
        payload: month,
        text: this.context.getIntlMessage('invite.oneMonth')
      },
      {
        payload: 3 * month,
        text: this.context.getIntlMessage('invite.threeMonths')
      },
      {
        payload: year / 2,
        text: this.context.getIntlMessage('invite.sixMonths')
      },
      {
        payload: year,
        text: this.context.getIntlMessage('invite.oneYear')
      },
      {
        payload: year * 1.5,
        text: this.context.getIntlMessage('invite.oneAndHalfYear')
      },
      {
        payload: year * 2,
        text: this.context.getIntlMessage('invite.twoYears')
      },
    ];
    const period = Math.floor(ucpPeriod / month);
    let selectedIndex = menuItems.findIndex(access => access.payload === ucpPeriod);
    if (selectedIndex < 0) {
      if (period > 18) {
        selectedIndex = 6;
      } else if (period > 12) {
        selectedIndex = 5;
      } else if (period > 6) {
        selectedIndex = 4;
      } else if (period > 3) {
        selectedIndex = 3;
      } else if (period > 1) {
        selectedIndex = 2;
      } else {
        selectedIndex = 1;
      }
    }


    return (
      <div>
        <RaisedButton
          label={this.context.getIntlMessage('Save')}
          onTouchTap={this.queueSave}
          backgroundColor={themeColor}
          fullWidth
          secondary
        />
        <SelectField
          onChange={this.changeAccessTime}
          floatingLabelText={this.context.getIntlMessage('course.access')}
          floatingLabelStyle={{
            transform: 'perspective(1px) scale(0.75) translate3d(2px, -28px, 0)'
          }}
          menuItems={menuItems}
          selectedIndex={selectedIndex}
          fullWidth
        />
        <TextField
          fullWidth
          multiline
          floatingLabelText={this.context.getIntlMessage('store.grossPrice')}
          defaultValue={Math.round(price.gross * 100) / 100}
          onChange={this.changePrice}
        />
        <Toggle
          label={this.context.getIntlMessage('store.public')}
          defaultToggled={isPublic}
          onToggle={this.statusChange}
        />
        <TextField
          fullWidth
          floatingLabelText={this.context.getIntlMessage('store.video')}
          hintText={this.context.getIntlMessage('store.video')}
          defaultValue={videoUrl}
          onChange={this.changeVideo}
        />
        <div style={styles.ozitor}>
          <Ozitor
            disabledControls={Constants.OZITOR_DISABLED_CONTROLS}
            editable
            defaultContent={presentation}
            onChange={this.changePresentation}
          />
        </div>
        <RaisedButton
          label={this.context.getIntlMessage('Save')}
          onTouchTap={this.queueSave}
          backgroundColor={themeColor}
          fullWidth
          secondary
        />
      </div>
    );
  }
}

export default StoreItemEditPanel;



// WEBPACK FOOTER //
// ./src/js/components/Store/StoreItemEditPanel.js